import { useMemo } from "react";
import classNames from "classnames";

import {
  PaginateFirstIcon,
  PaginateLastIcon,
  PaginateNextIcon,
  PaginatePrevIcon,
} from "src/common/assets/icons";
import { CSelect } from "src/common/components/controls";
import { PAGINATIONOPTIONS } from "src/configs/constant";

import { getPagination } from "./util";

const disableClassname =
  "disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-200";

export const CPagination = ({
  page = 1,
  pages = 1,
  limit = 10,
  total = 0,
  onPageChange = () => {},
  onLimitChange,
}) => {
  //#region Data
  const paginations = useMemo(() => {
    return getPagination(pages, page, Math.min(4, pages));
  }, [page, pages]);
  //#endregion

  //#region Event
  const onFirst = () => onPageChange?.(1);

  const onPrev = () => onPageChange?.((page = 1));

  const onNext = () => onPageChange?.(page + 1);

  const onLast = () => onPageChange?.(pages);
  //#endregion

  //#region Render
  return (
    <div className="flex flex-row items-center gap-4 mt-4 w-full justify-center">
      {total && total !== 0 && total > 0 ? (
        <span className="text-base font-medium text-sky-700">{`Tổng: ${total}`}</span>
      ) : (
        ""
      )}
      <CSelect
        value={limit}
        select="value"
        options={PAGINATIONOPTIONS}
        disabled={!Boolean(onLimitChange)}
        onChange={onLimitChange}
      />

      <div className="flex flex-row items-center">
        <button
          className={classNames(
            "outline-none p-[6px] rounded-l-lg",
            disableClassname,
          )}
          style={{ border: "1px solid #BABABAFF" }}
          disabled={page === 1}
          onClick={onFirst}
        >
          <PaginateFirstIcon className="h-6 w-6 text-sky-700" />
        </button>
        <button
          className={classNames("outline-none p-[6px]", disableClassname)}
          style={{ border: "1px solid #BABABAFF" }}
          disabled={page === 1}
          onClick={onPrev}
        >
          <PaginatePrevIcon className="h-6 w-6 text-sky-700" />
        </button>
        {paginations.map((p, i) =>
          p === "..." ? (
            <span
              key={p + i + new Date().getTime()}
              className={classNames("outline-none p-[6px] select-none")}
              style={{ border: "1px solid #BABABAFF" }}
            >
              <span className="h-6 min-w-6 flex items-center justify-center">
                ...
              </span>
            </span>
          ) : (
            <button
              key={p + i + new Date().getTime()}
              className={classNames(
                "outline-none p-[6px]",
                page === p && "bg-sky-600",
              )}
              style={{ border: "1px solid #BABABAFF" }}
              onClick={() => onPageChange(p)}
            >
              <span
                className={classNames(
                  "h-6 min-w-6 flex items-center justify-center text-sky-700",
                  page === p && "text-white font-semibold",
                )}
              >
                {p}
              </span>
            </button>
          ),
        )}
        <button
          className={classNames("outline-none p-[6px]", disableClassname)}
          style={{ border: "1px solid #BABABAFF" }}
          disabled={page === pages}
          onClick={onNext}
        >
          <PaginateNextIcon className="h-6 w-6 text-sky-700" />
        </button>
        <button
          className={classNames(
            "outline-none p-[6px] rounded-r-lg",
            disableClassname,
          )}
          style={{ border: "1px solid #BABABAFF" }}
          disabled={page === pages}
          onClick={onLast}
        >
          <PaginateLastIcon className="h-6 w-6 text-sky-700" />
        </button>
      </div>
    </div>
  );
  //#endregion
};
